import { render, staticRenderFns } from "./ShowNotice.vue?vue&type=template&id=e0bc4706&scoped=true&"
import script from "./ShowNotice.vue?vue&type=script&lang=js&"
export * from "./ShowNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bc4706",
  null
  
)

export default component.exports